module.exports = __webpack_public_path__ + "static/img/WI.0ca1620.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/listings/states/WI.jpg
// module id = a4Kk
// module chunks = 0